import { useNavigate } from 'react-router-dom';
import { useQuestionnaireSummaries } from '@app/view-creator/Admin/QuestionnaireAdminViewCreator';

/** Runs the questionnaire list: the questionnaires, and where each button goes. */
export const useQuestionnairesController = () => {
  const navigate = useNavigate();
  const summariesQuery = useQuestionnaireSummaries();

  return {
    loading: summariesQuery.isLoading,
    loadFailed: summariesQuery.isError || !summariesQuery.data,
    questionnaires: summariesQuery.data ?? [],
    handleBack: () => navigate('/admin'),
    handleResults: () => navigate('/admin/questionnaires/results'),
    handleSchedules: () => navigate('/admin/questionnaires/schedules'),
    handleNew: () => navigate('/admin/questionnaires/new'),
    handleOpen: (formId: number) => navigate(`/admin/questionnaires/${formId}`),
  };
};
